
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { CardRequest, CardResponse } from "@/api/interfaces";

export const advantageApi = createApi({
  reducerPath: "advantageCardReducer",
  baseQuery: fetchBaseQuery({ baseUrl: site.baseUrl }),
  endpoints: (builder) => ({
    requestDiscountCard: builder.mutation<CardResponse, CardRequest>({
      query: (payload) => {
        return {
          url: "/discount_card/send",
          method: "POST",
          body: payload,
        };
      },
    }),
  }),
});

export const {
  useRequestDiscountCardMutation,
} = advantageApi;
